import React, { useEffect } from "react";
import './App.css';
import { CssBaseline } from "@mui/material";
import { DarkModeProvider } from "./context/DarkModeContext";
import { useTranslation } from 'react-i18next';
// import Cookies from 'js-cookie';
// import { HelmetProvider } from 'react-helmet-async';
import RoutesPath from './routes';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "react-hot-toast";
import { getOrCreateDeviceId } from "./utils/helpers";
import { getFCMToken } from "./firebase";
import { getDeviceType } from "./utils/deviceDetection";
import { sendDeviceToken } from "./services/apiDeviceTokens";

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       staleTime: 0,
//       gcTime: 0,
//       refetchOnMount: 'always',
//       refetchOnWindowFocus: true,
//       refetchOnReconnect: false,
//       retry: 1,
//       retryDelay: 1000,
//     }
//   }
// });
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
      retryDelay: 1000,
    }
  }
});


function App() {
  useEffect(() => {
    // فحص إذا كان التطبيق مثبت ولم يتم إرسال Token
    const checkAndSendToken = async () => {
      const isInstalled = window.matchMedia('(display-mode: standalone)').matches;
      const tokenSentAt = localStorage.getItem('fcm_token_sent_at');
      const lastTokenDate = tokenSentAt ? new Date(tokenSentAt) : null;
      const daysSinceLastSend = lastTokenDate
        ? (new Date() - lastTokenDate) / (1000 * 60 * 60 * 24)
        : Infinity;

      // إعادة إرسال Token كل 7 أيام
      if (isInstalled && daysSinceLastSend > 7) {
        try {
          const fcmToken = await getFCMToken();
          if (fcmToken) {
            const deviceType = getDeviceType();
            await sendDeviceToken({ fcm_token: fcmToken, device_type: deviceType });
            localStorage.setItem('fcm_token_sent_at', new Date().toISOString());
          }
        } catch (error) {
          console.error('Error refreshing FCM token:', error);
        }
      }
    };

    checkAndSendToken();
  }, []);
  const { i18n } = useTranslation();
  useEffect(() => {
    getOrCreateDeviceId();
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  return (
    <>
      <BrowserRouter>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <DarkModeProvider>
            <CssBaseline />
            <RoutesPath />
            <Toaster
              position="top-center"
              gutter={12}
              containerStyle={{ margin: "8px" }}
              toastOptions={{
                success: {
                  duration: 6000,
                },
                error: {
                  duration: 5000,
                },
                style: {
                  fontSize: "16px",
                  maxWidth: "500px",
                  padding: "16px 24px",
                  backgroundColor: theme => theme.palette.primary.main,
                  color: "var(--color-grey-700)",
                },
              }}
            />
          </DarkModeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </>
  );
}

export default App;